var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-file',{staticClass:"dragAndDrop",attrs:{"accept":".arff, .csv, .txt, .json","size":"lg","state":Boolean(_vm.file),"browse-text":"Browse","placeholder":_vm.nameOfPlaceHolder,"drop-placeholder":_vm.nameOfDropPlaceHolder,"title":""},on:{"change":_vm.loadTextFromFile}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e32d9ea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DataLoading/FileReader.vue
// module id = null
// module chunks = 